/**
 * Maps a masterdata record to the tool-argument vocabulary ai-mcp's statistics
 * tools speak, so a mention lands in the query as an id instead of a label.
 * An entity without a mapping still resolves — it just carries no argument.
 */
export function mentionToolArgument(
  entity: string,
  key: string
): Record<string, unknown> | undefined {
  switch (entity) {
    case 'customer': {
      const id = Number(key);
      return Number.isFinite(id) ? { customer_id_list: [id] } : undefined;
    }
    case 'product':
      return { product_id: key };
    case 'product-group':
      return { product_group_id: key };
    default:
      return undefined;
  }
}
